import { useDispatch, useSelector } from 'react-redux';
import {
  selectClient,
  selectSession,
  selectSessionAdvisor,
  putMultipleFundingSourceForClientByClientIdRequest,
} from '@/model';
import { SessionType } from '@shared';
import { createTraditionalLTCFundingSource } from '@/features/shop-insurance';

interface UseTraditionalLTCPolicyManagementProps {
  quote: TraditionalLTCQuote;
  fundingSourceId?: string | null;
}

export function useTraditionalLTCPolicyManagement({
  quote,
  fundingSourceId = null,
}: UseTraditionalLTCPolicyManagementProps) {
  const dispatch = useDispatch();
  const client = useSelector(selectClient);
  const { sessionType } = useSelector(selectSession);
  const advisor = useSelector(selectSessionAdvisor);

  const isAdvisorSession =
    sessionType === SessionType.advisor || sessionType === SessionType.wizard;

  const handleAddPolicy = (event: React.MouseEvent) => {
    event.stopPropagation();

    if (!client) return;

    const finalPolicy = createTraditionalLTCFundingSource(
      quote,
      advisor?.advisorId,
      isAdvisorSession,
    );

    dispatch(
      putMultipleFundingSourceForClientByClientIdRequest({
        clientId: client.clientId,
        fundingSourceType: 'ltcPolicy',
        fundingSourceData: finalPolicy,
        fundingSourceId: null,
      }),
    );
  };

  const handleRemovePolicy = (event: React.MouseEvent) => {
    event.stopPropagation();

    if (!client || !fundingSourceId) return;

    dispatch(
      putMultipleFundingSourceForClientByClientIdRequest({
        clientId: client.clientId,
        fundingSourceType: 'ltcPolicy',
        fundingSourceData: null,
        fundingSourceId,
      }),
    );
  };

  return {
    handleAddPolicy,
    handleRemovePolicy,
  };
}
